import React, { useState } from "react";
import { IBannerMultimedyaResponseModel } from "../../core/models";
import "./bannermultimedya.scss";
import ModalVideo from "react-modal-video";

export interface IBannerMultimedyaProps {
  content: IBannerMultimedyaResponseModel;
}

const BannerMultimedya = ({ content }: IBannerMultimedyaProps) => {
  const [isOpen, setOpen] = useState(false);

  if (window && (window as any)["ReactNativeWebView"]) {
    (window as any)["ReactNativeWebView"].postMessage(
      JSON.stringify({
        message: "eventLogForCountly",
        eventName: "event-5",
        eventSegment: {
          multimediaSelected: true,
        },
        actionType: "event",
      })
    );

    (window as any)["ReactNativeWebView"].postMessage(
      JSON.stringify({
        message: "eventLogForCountly",
        eventName: "segment-1",
        eventSegment: {
          title: content.title,
        },
        actionType: "event",
      })
    );
  }

  return (
    <section className="banner-multimedya">
      <h2 className="banner-multimedya__title">{content.title}</h2>

      <React.Fragment>
        <ModalVideo
          channel="youtube"
          youtube={{
            mute: 0,
            autoplay: 1,
            showinfo: 0,
            controls: 0,
            cc_load_policy: 0,
          }}
          isOpen={isOpen}
          videoId={content.url}
          onClose={() => setOpen(false)}
        />
        <button
          className="banner-multimedya__head-image"
          onClick={() => setOpen(true)}
        >
          <img
            src={content.image?.src}
            width={375}
            height={194}
            alt={content.image?.alt}
            style={{ height: "auto", width: "100%" }}
          />
          <span className="icon icon-play"></span>
        </button>
      </React.Fragment>
    </section>
  );
};

export default BannerMultimedya;
